import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setUserSettingsAction } from '../../../store/actions/profile';
import { updateUserSettings } from '../../../services/backendAPI';

export const useSettings = () => {
  const dispatch = useDispatch();
  const { userData, userSettings } = useSelector(state => state.profile);

  const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
  const [orderType, setOrderType] = useState('');
  const [productType, setProductType] = useState('');
  const [defaultQtyByExchange, setDefaultQtyByExchange] = useState({});
  const [settingsUpdated, setSettingsUpdated] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  useEffect(() => {
    if (userSettings) {
      setOrderType(userSettings.order_type);
      setProductType(userSettings.product_type);
      const initialized = {};
      const defaultQtyObj = userSettings.default_qty_by_exchange || {};
      ['NSE', 'BSE', 'NFO', 'BFO', 'MCX', 'DCSX', 'CDS', 'US'].forEach(ex => {
        initialized[ex] = defaultQtyObj[ex] !== undefined ? defaultQtyObj[ex] : 1;
      });
      setDefaultQtyByExchange(initialized);
    }
  }, [userSettings]);

  const handleSaveSettings = async () => {
    const settingsUpdatePayload = {
      order_type: orderType,
      product_type: productType,
      client_id: userData?.client_id || userSettings?.client_id
    };

    const finalQtyObj = {};
    Object.entries(defaultQtyByExchange).forEach(([ex, val]) => {
       const num = parseInt(val, 10);
       if (!isNaN(num) && num > 0) {
           finalQtyObj[ex] = num;
       }
    });

    if (Object.keys(finalQtyObj).length > 0) {
      settingsUpdatePayload.default_qty_by_exchange = finalQtyObj;
    }

    try {
      dispatch({ type: 'UPDATE_USER_SETTINGS_START' });
      await updateUserSettings(settingsUpdatePayload);

      dispatch(setUserSettingsAction({
        ...userSettings,
        ...settingsUpdatePayload
      }));

      dispatch({ type: 'UPDATE_USER_SETTINGS_SUCCESS' });
      setSettingsUpdated(true);
      setTimeout(() => setSettingsUpdated(false), 3000);
      setOpenSettingsDialog(false);
      if (updateError) setUpdateError(null);
    } catch (error) {
      console.error('Error updating settings:', error);
      const errorMessage = error?.message || error?.toString() || 'Failed to update settings';
      dispatch({ type: 'UPDATE_USER_SETTINGS_FAILURE', payload: errorMessage });
      setUpdateError(errorMessage);
    }
  };

  return {
    openSettingsDialog,
    setOpenSettingsDialog,
    orderType,
    setOrderType,
    productType,
    setProductType,
    defaultQtyByExchange,
    setDefaultQtyByExchange,
    settingsUpdated,
    setSettingsUpdated,
    updateError,
    setUpdateError,
    handleSaveSettings,
  };
};

